/**
 * Asserts that subject is an array with values, and that each value is of the same root type
 * @todo it would be great to be able to pass in a non-base base type checker method
 */
export function isNonEmptyUniformArray(subject, valueType) {
    return isUniformArray(subject, valueType) && subject.length > 0;
}
/**
 * Asserts that subject is an array and (if non-empty) that all values match the specified type
 */
export function isUniformArray(subject, valueType) {
    const checker = typeof valueType === 'function' ? valueType : (item) => typeof item === valueType;
    return Array.isArray(subject) && subject.every(checker);
}
/**
 * Used in typechecking, asserts the subject is a defined object of type.
 *
 * Please note that this does not actually verify that it is the type, that
 * must be done inside of the consuming typechecking function.
 */
export function coerceToNonEmpty(subject) {
    if (typeof subject !== 'object' || subject === null) {
        return false;
    }
    return subject;
}
/**
 * Used for filtering out undefined/null/empty values from an array
 */
export function filterNonEmpty(item) {
    return (item !== undefined &&
        item !== null &&
        !(Array.isArray(item) && item.length === 0) &&
        !(typeof item === 'object' && Object.values(item).length === 0));
}
//# sourceMappingURL=utility.js.map